<template>
	<div class="main" v-loading="list_loading">
		<mybread></mybread>
		<el-table :data="fileData" border style="width: 100%">
			<el-table-column prop="id" label="id">
			</el-table-column>
			<el-table-column prop="idcardno" label="身份证号">
			</el-table-column>
			<el-table-column prop="elderName" label="用户姓名">
			</el-table-column>
			<el-table-column prop="phone" label="手机号码">
			</el-table-column>
			<el-table-column prop="deviceSid" label="设备厂号">
			</el-table-column>
			<el-table-column prop="createTime" label="日期">
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="warning" @click="handleDetail(scope.row)" icon="el-icon-view">查看</el-button>
					<el-button size="mini" type="success" @click="handlePush(scope.row)" icon="el-icon-s-promotion">推送</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" background @size-change="handleSizeChange" :page-sizes='[5,10,20]' :page-size='pageSize' layout="sizes,prev, pager, next,total,jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import mybread from "@/components/bread"
	export default {
		components: {
			mybread
		},
		inject: ['reload'],
		data() {
			return {
				total: 0, //总页数
				pageSize: 10, //每页条数
				currentPage: 1, //当前页（默认第一页）
				fileData: [],
				detail_dv: false,
				detail_loading: false,
				dialogUserInfo: [],
				list_loading:true
			}
		},
		created() {
			this.getFileData()
		},

		methods: {
			handleCurrentChange(val) {
				this.currentPage = val; //获取当前页
				this.getFileData();
			},
			handleSizeChange(psize) { //选择每页条数
				this.pageSize = psize;
				this.getFileData();
			},
			getFileData() {
				const data = {
					length: this.pageSize,
					start: (this.currentPage - 1) * this.pageSize
				}
				this.$get("api/nurseElderly/listData", data).then(res => {
					this.fileData = res.data
					this.total = res.recordsFiltered
					this.list_loading=false
					this.fileData.map(val=>{
						if(val.idcardno){
							val.idcardno=val.idcardno.substr(0,6)+"********"+val.idcardno.substr((val.idcardno.length-6),4)
						}
						if(val.phone){
							val.phone=val.phone.substr(0,4)+"*****"+val.phone.substr((val.phone.length-2),2)													
						}
					})
				}).catch((e) => {
					window.console.log(e)
				})

			},
			handleDetail(row) { //查看
				this.$router.push({
					path: 'old-file',
					query: {
						id: row.id
					}
				});
			},

			handlePush(row) {
				this.$confirm('是否推送', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const data = {
						id: row.id
					}
					this.$get("api/nurseElderly/sendData", data).then(res => {
						if (res.success === 1) {
							this.$message({
								type: 'success',
								message: res.data
							})
						} else {
							this.$message({
								type: 'error',
								message: res.data
							})
						}
					}).catch((e) => {
						window.console.log(e)
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消推送'
					});
				});
			}
		}
	}
</script>

<style scoped="scoped">
	.main .block {
		text-align: center;
		margin-top: 20px;
	}

	.main {
		background: #fff;
		padding: 0 20px 20px 20px;
	}
</style>
